import {ChangeDetectionStrategy, Component, inject, input, output} from '@angular/core';
import {FormGroup, ReactiveFormsModule} from "@angular/forms";
import {certificateResourceType} from "../../configs/certificate-modal-config";
import {certificateFormFields} from "../../configs/certificate-form-fields";
import {CertificateData, CreateCertificateParams} from "../../types/certificate-modal.types";
import {defaultCertificateData} from "../../configs/default-certificate-data";
import {CertificateModalService} from "../../services/certificate-modal.service";
import {RecordUpdateRequestParams} from "../../../../../../../../core/types/records-table.types";
import {MatFormField, MatInput, MatLabel} from "@angular/material/input";
import {CdkTextareaAutosize} from "@angular/cdk/text-field";
import {MatButton} from "@angular/material/button";

@Component({
  selector: 'app-certificate-form',
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    CdkTextareaAutosize,
    MatButton
  ],
  templateUrl: './certificate-form.component.html',
  styleUrls: [
    '../../certificate-modal.component.scss',
    './certificate-form.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CertificateFormComponent {
  parentId = input<number>(0);
  certificateData = input<CertificateData>(defaultCertificateData);
  certificateFormGroup = input<FormGroup>(new FormGroup({}));
  noFirstData = input<boolean>(false);
  isEditModeActive = input<boolean>(false);
  updateCertificateData = output<CertificateData>();
  deleteCertificate = output<void>();

  private certificateModalService: CertificateModalService = inject(CertificateModalService);

  public readonly certificateFormFields = certificateFormFields;

  public getFieldClass(): string {
    if (!this.certificateData().id) { return ''; }

    return this.isEditModeActive() ? '' : 'none-pointer-events';
  }

  public async handleValueChange(key: string): Promise<void> {
    if (!this.certificateData().id) { return; }

    const params: RecordUpdateRequestParams = {
      path: certificateResourceType.path,
      recordId: this.certificateData().id,
      fieldName: key,
      value: this.certificateFormGroup().get(key)?.value
    };

    const data = await this.certificateModalService.updatedRecordField<CertificateData>(params)
      .catch(() => this.certificateData());
    this.updateCertificateData.emit(data);
  }

  public handelDelete(): void {
    this.deleteCertificate.emit();
  }

  public async handelCreate(): Promise<void> {
    const createCertificateParams: CreateCertificateParams = {
      technicalParametersId: this.parentId(),
      ...this.certificateFormGroup().value
    };

    const data = await this.certificateModalService.createCertificate(createCertificateParams)
      .catch(() => defaultCertificateData);
    this.updateCertificateData.emit(data);
  }
}
